import styled from 'styled-components'

import { media, mediaMax } from 'styles/media'
import typeStyle from 'styles/typeStyle'

import Signup from './Signup'
import { Subheading } from './styles'

const HeaderWrapper = styled.div`
  background-color: ${({ theme }) => theme?.['-ds-core-50']?.value};
  width: 100%;

  ${mediaMax.md`
    padding: 0 16px;
  `}
`

const HeaderInner = styled.div`
  max-width: 990px;
  margin: 0 auto;
  padding: 80px 0;

  text-align: center;
  color: ${({ theme }) => theme?.['-ds-core-300']?.value};

  ${media.md`
    padding: 120px 0;
  `}
`

const PageTitle = styled.h1`
  ${typeStyle('-ds-font-title-large-regular')}
  margin-bottom: 16px;
  text-align: center;
`

interface HeaderProps {
  cityName: string
  marketName: string
  marketCode?: string
}

const Header = ({ cityName, marketName, marketCode }: HeaderProps) => {
  return (
    <HeaderWrapper>
      <HeaderInner>
        <PageTitle>{cityName}, it’s almost time for a vacation.</PageTitle>

        <Subheading>
          Whether you’re chasing adventure or time out in nature, we’re here to
          help you plan and book your next short nature escape. For news about
          our 2022 launch in {marketName}, early bookings and adventure advice,
          sign up and stay in the know!
        </Subheading>

        <Signup marketCode={marketCode} />
      </HeaderInner>
    </HeaderWrapper>
  )
}

export default Header
